// extracted by mini-css-extract-plugin
export default {"loading_spinner":"loader_loading_spinner__EtD7e","spinner":"loader_spinner__g3Jqs"};